import React, { useRef, useEffect, useState } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { WidgetCard } from '../WidgetCard';
import { Popup, Dropdown } from 'semantic-ui-react';
import { widgetHeight, widgetWidth } from '..';
import { BottomButtonRow, Message, CardBodyWrapper } from '../Styles';
import ButtonWithConfirmation from '../ButtonWithConfirmation';
import useStores from '../../../../hooks/use-store';
import { useAuctionAndLanes } from '../Streamer/SwitchStreamerWidget';
import { engineToolType } from '../../../../stores/reducers/engineTools';

export const EngineReloadAuctionWidget = observer(() => {
  const {
    AuctionStore: { sortedActiveAuctions, getSortedActiveAuctions },
    EngineToolStore: { enginePost: post, widgetReloading },
  } = useStores();

  const key = 'reload-auction';

  const { onAuctionChanged, auction, isLoadingAuctions, auctions } =
    useAuctionAndLanes({
      sortedActiveAuctions,
      getSortedActiveAuctions,
      enableLaneLoading: false,
    });

  const [message, setMessage] = useState(null);
  const [success, setSuccess] = useState(null);

  const statusMessageHandler = ({ success, message }) => {
    setMessage(message);
    setSuccess(success);
  };

  const handleConfirmation = (e) => {
    e.preventDefault();
    post(engineToolType.reloadAuction, { auctionID: auction.auctionId }).then(
      statusMessageHandler,
    );
  };

  const isLoading =
    isLoadingAuctions || widgetReloading[engineToolType.reloadAuction];

  console.log('auction', auction);
  return (
    <WidgetCard
      heading="Reload Auction"
      description="Forces the Engine to Reload an Auction from the Database."
      width="450px"
      height="235px"
    >
      <CardBodyWrapper>
        <Dropdown
          placeholder="Select Auction"
          clearable
          fluid
          selection
          options={auctions}
          onChange={(e, data) => {
            onAuctionChanged(data.value, e.currentTarget.textContent);
            statusMessageHandler({ success: null, message: null });
          }}
          disabled={isLoading}
        />
      </CardBodyWrapper>
      <BottomButtonRow buttonWidth="180px">
        {message ? (
          <Popup
            data-testid={`${key}-popup`}
            key={key}
            content={message}
            header="Details"
            size="small"
            trigger={
              <Message success={success}>
                {success
                  ? '😃 The auction has been successfully reloaded!'
                  : '🤔 Oops, an error occurred while trying to reload the auction.'}
              </Message>
            }
          />
        ) : (
          <Message />
        )}
        <ButtonWithConfirmation
          buttonText="Reload Auction"
          buttonIcon="sync"
          onConfirmation={handleConfirmation}
          loading={isLoading}
          disabled={!auction?.auctionId}
        />
      </BottomButtonRow>
    </WidgetCard>
  );
});

export default EngineReloadAuctionWidget;
